import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from "react-datepicker";
import { ApiService } from "../../../services/ApiService";
import { Formik, Form, Field } from "formik";
import { useAlert } from "react-alert";
import Select from "react-select";

export const AddNew = () => {
  //   const [users, setUsers] = useState([]);
  const alert = useAlert();

  //   const request = async () => {
  //     const getUser = await await ApiService.post("get-all-active-users");
  //     console.log(getUser);
  //     setUsers(getUser.data.data);
  //   };

  //   useEffect(() => {
  //     request();
  //   }, []);
  console.log("Hello");
  return (
    <React.Fragment>
      <TrainingNavbar />
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="table-wrapper table-responsive">
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-xs-12"
                    id="munch_learn_content_wrapper"
                  >
                    <div class="">
                      <Formik
                        initialValues={{
                          name: "",
                          presentation_type: "",
                          due_date: "",
                          email: "",
                          users_email: "",
                          topic: "",
                        }}
                        onSubmit={(values) => {
                          // console.log(values);
                          // ApiService.post(
                          //   "trainings/create-munch-and-learn",
                          //   values
                          // ).then((res) => {
                          //   console.log(res);
                          //   if (res.data.type === false) {
                          //     alert.error(res.data.msg);
                          //   } else if (res.data.type === true) {
                          //     alert.success(res.data.msg);
                          //   }
                          // });
                        }}
                      >
                        {({
                          isSubmitting,
                          values,
                          setFieldValue,
                          handleChange,
                          setFieldTouched,
                        }) => (
                          <Form>
                            <div>
                              <div className="form-group">
                                <label>
                                  Presentation Type{" "}
                                  <span className="text-danger"> * </span>
                                </label>
                                <select
                                  as="select"
                                  className="form-control"
                                  id="presentation_type"
                                  name="presentation_type"
                                  required
                                >
                                  <option value="">
                                    --Select Presentation Type--
                                  </option>
                                  <option value="individual">Individual</option>
                                  <option value="paired">Paired</option>
                                  <option value="guest">Guest</option>
                                </select>
                              </div>

                              <div className="form-group">
                                <label>
                                  Presenter{" "}
                                  <span className="text-danger"> * </span>
                                </label>

                                {values.presentation_type == "individual" ? (
                                  <select
                                    as="select"
                                    className="form-control"
                                    name="name"
                                  >
                                    <option selected>--Select User--</option>

                                    {/* {users.map((user, i) => (
                                      <option
                                        value={
                                          user.first_name + " " + user.last_name
                                        }
                                        key={i}
                                      >
                                        {user.first_name + " " + user.last_name}
                                      </option>
                                    ))} */}
                                  </select>
                                ) : null}

                                {/* {values.presentation_type == "paired" ? (
                                  <Select
                                    isMulti
                                    value={values.name}
                                    options={users.map((user) => ({
                                      label:
                                        user.first_name + " " + user.last_name,
                                      value:
                                        user.first_name + " " + user.last_name,
                                    }))}
                                    onChange={(date) =>
                                      setFieldValue("name", date)
                                    }
                                  />
                                ) : null} */}

                                {values.presentation_type == "guest" ? (
                                  <Field
                                    type="text"
                                    id="tpoic"
                                    className="form-control item"
                                    name="name"
                                    placeholder="Enter Guest Name"
                                    required
                                  />
                                ) : null}
                              </div>

                              <div className="form-group">
                                <label>
                                  Presenter Email{" "}
                                  <span className="text-danger"> * </span>
                                </label>
                                {/* <Field as="select" className="form-control" name="email">

                                                        {users.map((user, i) => (
                                                                <option value={user.email} key={i}>
                                                                {user.email}
                                                                </option>
                                                            ))}
                                                    </Field> */}
                                <Field
                                  name="email"
                                  value={values.email}
                                  className="form-control item"
                                  placeholder="Enter Topic"
                                />
                              </div>
                              <div className="form-group">
                                <label>
                                  Due Date{" "}
                                  <span className="text-danger"> * </span>
                                </label>
                                <div className="form-group">
                                  <DatePicker
                                    selected={values.due_date}
                                    dateFormat="MMMM d, yyyy"
                                    className="form-controls"
                                    name="due_date"
                                    onChange={(date) =>
                                      setFieldValue("due_date", date)
                                    }
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label>Topic</label>
                                <Field
                                  type="text"
                                  id="tpoic"
                                  className="form-control item"
                                  name="topic"
                                  placeholder="Enter Topic"
                                  required
                                />
                              </div>
                              <div className="form-group">
                                <button
                                  type="submit"
                                  className="btn btn-block nt-button-color-default"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/add_new.js